export const headCells = [
  {
    id: 'status',
    orderName: 'status',
    displayName: 'sendList.table.status',
    align: 'center',
    width: '102px',
    sortable: true
  },
  {
    id: 'weeklyReportName',
    orderName: 'weeklyReportName',
    displayName: 'sendList.table.name',
    align: 'left',
    width: '360px',
    maxWidth: '360px',
    sortable: true
  },
  {
    id: 'sendDay',
    orderName: 'sendDay',
    displayName: 'sendList.table.date',
    align: 'left',
    width: '200px',
    sortable: true
  }, {
    id: 'sendTime',
    orderName: 'sendTime',
    displayName: 'common.sendDate.sendTime',
    align: 'left',
    width: '100px',
    sortable: true
  }, {
    id: 'facebookAccounts',
    orderName: 'facebookAccounts',
    displayName: 'common.account',
    align: 'left',
    width: null,
    maxWidth: '220px',
    sortable: false
  }, {
    id: 'toAddresses',
    orderName: 'toAddresses',
    displayName: 'sendList.table.toAddresses',
    align: 'left',
    width: null,
    maxWidth: '200px',
    sortable: false
  }, {
    id: 'editReport',
    orderName: 'editReport',
    displayName: 'common.button.edit',
    align: 'center',
    width: '60px',
    sortable: false
  }, {
    id: 'copyReport',
    orderName: 'copyReport',
    displayName: 'common.button.copy',
    align: 'center',
    width: '60px',
    sortable: false
  }, {
    id: 'transferReport',
    orderName: 'transferReport',
    displayName: 'sendList.table.transfer',
    align: 'center',
    width: '60px',
    sortable: false
  }, {
    id: 'deleteReport',
    orderName: 'deleteReport',
    displayName: 'common.button.delete',
    align: 'center',
    width: '60px',
    sortable: false
  }
];
